import { Injectable } from '@angular/core';
import { Address } from './shared.interface';

@Injectable({
	providedIn: 'root'
})
export class SharedService 
{
	
	public formatAddress(address: Address, formatCompleteAddress: boolean) 
	{
		if (formatCompleteAddress) 
		{
			return [ address.addressLine1, address.addressLine2, address.city, address.state, address.zipCode ].filter(Boolean).join(', ');
		}
		else 
		{
			return [ address.city, address.state, address.zipCode ].filter(Boolean).join(', ');
		}
	}
}
